import Element, { ElementType, SpecyficType } from '../element';
import { ISapElement } from '../api/models/sapElement';
import { ISimpleSapElement, SimpleSapElement } from '../api/models/simpleSapElement';
import { ElementToSimpleSapElementMapperAbstractFactory } from './mappers/elementToSimpleSapElementMapperAbstractFactory';
import store from '@/store';

export class ElementsToSapElementsConverter {

    private elementToSimpleSapElementMapperAbstractFactory = new ElementToSimpleSapElementMapperAbstractFactory();

    public convert(sapElements: ISapElement[], elements: Element[]): ISapElement[] {
        const result: ISapElement[] = [];
        let hasLegs = false;
        let hasHandle = false;
        elements.forEach((element) => {
            if (element.type === ElementType.LEGS) {
                if (hasLegs) { return; }
                hasLegs = true;
            }
            if (element.type === ElementType.HANDLE) {
                if (hasHandle) { return; }
                hasHandle = true;
            }
            const type = this.toType(element);
            if (type === '') { return; }
            const color = this.toColor(element);
            if (color === '') { return; }
            const sapElement = sapElements.find((x) =>
                x.type === type && x.color === color);
            if (!sapElement) { return; }
            result.push(sapElement);
        });
        return result;
    }

    public convertAlone(elements: Element[]): ISimpleSapElement[] {
        const result = [];
        elements.forEach((x) => {
            const mapper = this.elementToSimpleSapElementMapperAbstractFactory.get().getMapperFor(x);
            const simpleSapElements = mapper.map(x);
            result.push(...simpleSapElements);
        });
        if (store.getters.shaders.selectedHandle.shader.key === 'ShaderNull') {
            elements
                .filter((x) => x.specyficType === SpecyficType.REGULAR_FRONT)
                .forEach((x) => {
                    const mapper = this.elementToSimpleSapElementMapperAbstractFactory.get().getMapperFor(x);
                    const frontSimpleElements = mapper.map(x);
                    const handleSimpleElements = frontSimpleElements
                        .map((e) => SimpleSapElement.HANDLE('SPD_0_12', ''));
                    result.push(...handleSimpleElements);
                });
        }
        return result;
    }

    private toType(element: Element): string {
        const type = element.type;
        const specyficType = element.specyficType;
        if (type === ElementType.LEGS) {
            return this.toLegsType(element);
        }
        if (type === ElementType.HANDLE) {
            return this.toHandleType(element);
        }
        if (type === ElementType.BODY) { return this.toSizeType('KOS', element); }
        if (type === ElementType.FRONT) { return this.toSizeType('DRZ', element); }
        if (specyficType === SpecyficType.SHELF) { return this.toSizeType('POL', element); }
        if (specyficType === SpecyficType.VERTICAL_WALL) { return this.toSizeType('PPN', element); }
        if (specyficType === SpecyficType.HORIZONTAL_WALL) { return this.toSizeType('PPZ', element); }
        return '';
    }

    private toSizeType(type: string, element: Element): string {
        let width = element.shape.x;
        if (element.specyficType === SpecyficType.VERTICAL_WALL) {
            width = 1;
        }
        let height = element.shape.y;
        if (element.specyficType === SpecyficType.SHELF ||
            element.specyficType === SpecyficType.HORIZONTAL_WALL) {
            height = 1;
        }
        return `${type}_${height}_${width}`;
    }

    private toLegsType(element: Element): string {
        const shader = element.shaderName;
        if (shader === 'ShaderNSlizgacz') { return 'SLI'; }
        if (shader === 'ShaderNStPrzesun') { return 'S_SMS'; }
        if (shader === 'ShaderNStScieta') { return 'S_SDM'; }
        if (shader === 'ShaderNStStozek') { return 'S_SDCZ'; }
        if (shader === 'ShaderNStBox') { return 'S_SDCI'; }
        if (shader === 'ShaderNStProsta') { return 'S_RMC'; }
        if (shader === 'ShaderNStGiety') { return 'S_GMC'; }
        if (shader === 'ShaderNPlozy') { return 'P_MC'; }
        if (shader === 'ShaderNWalec') { return 'N_WDJ'; }
        if (shader === 'ShaderNStozek') { return 'N_SDC'; }
        if (shader === 'ShaderNBox') { return 'N_PDB'; }
        if (shader === 'ShaderNOkragla') { return 'N_MZ'; }
        return '';
    }

    private toHandleType(element: Element): string {
        const shader = element.shaderName;
        if (shader === 'ShaderNull') { return 'U_SP'; }
        if (shader === 'ShaderU01Siro') { return 'U_TDC'; }
        if (shader === 'ShaderU02Alus') { return 'U_WMC'; }
        if (shader === 'ShaderU03Schwinn') { return 'U_TMS'; }
        if (shader === 'ShaderU04Schwinn') { return 'U_SK'; }
        if (shader === 'ShaderU05Schwinn') { return 'U_GMZ'; }
        if (shader === 'ShaderU06Siro') { return 'U_WDJ'; }
        if (shader === 'ShaderU07Schwinn') { return 'U_GMC'; }
        if (shader === 'ShaderU08Schwinn') { return 'U_DMZ'; }
        if (shader === 'ShaderU09Siro') { return 'U_PDM'; }
        if (shader === 'ShaderU10Schwinn') { return 'U_DMC'; }
        if (shader === 'ShaderU11Schwinn') { return 'U_PMC'; }
        return '';
    }

    private toColor(element: Element): string {
        const shader = element.shaderName;
        if (shader === 'Shader6458') { return 'BIA'; }
        if (shader === 'ShaderU899') { return 'CZA'; }
        if (shader === 'ShaderH3162') { return 'D_BR'; }
        if (shader === 'ShaderH3157') { return 'D_JA'; }
        if (shader === 'ShaderH3396') { return 'D_MI'; }
        if (shader === 'ShaderH3325') { return 'DAB_CIE'; }
        if (shader === 'ShaderU599') { return 'IND'; }
        if (shader === 'ShaderU830') { return 'NUD'; }
        if (shader === 'ShaderU163') { return 'SZAF'; }
        if (shader === 'ShaderU8101') { return 'SZARY'; }
        if (shader === 'ShaderU606') { return 'ZIE'; }
        return '';
    }
}
